import { Section } from 'gossamer-front-end';
import * as React from 'react';

export interface EventDetailsSectionLayoutProps {
  title: string;
  subtitle: string;
  children: React.ReactNode;
}

export const EventDetailsSectionLayout = (props: EventDetailsSectionLayoutProps): React.JSX.Element => {
  return (
    <Section style={{ display: 'flex', gap: 24, alignItems: 'flex-start', flexWrap: 'wrap' }}>
      <div style={{ flex: '1 1 320px' }}>
        <h2 style={{ margin: 0, marginBottom: 8, fontSize: 20 }}>{props.title}</h2>
        <p style={{ margin: 0 }}>{props.subtitle}</p>
      </div>
      <div style={{ flex: '1 1 480px', maxWidth: 700, display: 'flex', flexDirection: 'column', gap: 16 }}>
        {props.children}
      </div>
    </Section>
  );
};
